var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-726.033 -628.695 1985.4 1937.02",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.3,
    y1: 1199.59,
    x2: 575.31,
    y2: 1199.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d11414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 181.03,
    y1: 671.28,
    x2: 720.17,
    y2: 671.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 716.43,
    y1: 302.52,
    x2: 1236.42,
    y2: 302.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 483.39,
    y1: 1684.63,
    x2: 990.12,
    y2: 1684.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1032.36,
    y1: 1664.21,
    x2: 1534.35,
    y2: 1664.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1427.84,
    y1: 1167.72,
    x2: 1992.7,
    y2: 1167.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1240.29,
    y1: 637.09,
    x2: 1773.99,
    y2: 637.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 539.07,
    y1: 1086.31,
    x2: 1066.48,
    y2: 1086.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1204.12,
    y1: 1055.87,
    x2: 676.7,
    y2: 1055.87,
    gradientTransform: "translate(2123.29 2064.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.73,1032.66l-.26.41c-3.06,6.28-6.25,12.53-9.51,18.74a785.6,785.6,0,0,1-193.66,238l.37.09a784.85,784.85,0,0,1,279.47,125.24c5.77,4.13,11.5,8.32,17.14,12.59l.41.25a184.17,184.17,0,0,0,270.62-85.36,484,484,0,0,1-79-168.85c-.47-1.76-.89-3.53-1.31-5.3a493.86,493.86,0,0,1-10.53-61.27,478.61,478.61,0,0,1,2.77-123.11,184.13,184.13,0,0,0-276.51,48.53Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M508.94,429.2l-.48.06q-10.23,2.33-20.57,4.34A785.55,785.55,0,0,1,181,432c.06.11.11.23.17.34a784.79,784.79,0,0,1,77.7,296.23c.41,7.08.74,14.17,1,21.24l.06.48a184.19,184.19,0,0,0,236.2,157.26,483.88,483.88,0,0,1,82-167.42c1.07-1.48,2.19-2.91,3.3-4.35a497.52,497.52,0,0,1,41.12-46.63,479.4,479.4,0,0,1,97.64-75.05A184.15,184.15,0,0,0,508.94,429.2Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1178.35,286.93l-.34-.34c-5.44-4.38-10.83-8.88-16.16-13.44A785.4,785.4,0,0,1,972.76,31.47c-.06.11-.12.23-.17.34A784.78,784.78,0,0,1,788.41,276.49c-5.3,4.71-10.66,9.37-16.08,13.91l-.33.35a184.18,184.18,0,0,0,23.13,282.82A483.82,483.82,0,0,1,977.31,534c1.82-.07,3.64-.09,5.46-.11a498.7,498.7,0,0,1,62.07,3.34,479.17,479.17,0,0,1,119.43,30.05,184.15,184.15,0,0,0,14.08-280.39Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.89,1719.12a184,184,0,0,0-6.68-164.44,479.16,479.16,0,0,1-121.44-20.44,495.63,495.63,0,0,1-58.19-21.87c-1.66-.74-3.32-1.49-5-2.29a483.89,483.89,0,0,1-151-109.35A184.18,184.18,0,0,0,496.9,1650.46l.17.45q4.69,9.51,9.13,19.2a784.75,784.75,0,0,1,70.43,298c0,.13,0,.25,0,.38a785.47,785.47,0,0,1,270.22-145.41q10.07-3.06,20.2-5.82l.45-.17A183.54,183.54,0,0,0,973.89,1719.12Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1512.36,1478.15a183.93,183.93,0,0,0-134.48-94.85,478.94,478.94,0,0,1-90.18,83.86,495,495,0,0,1-52.78,32.83c-1.61.86-3.21,1.73-4.84,2.54a484.11,484.11,0,0,1-178.69,53.13,184.2,184.2,0,0,0,116,259l.46.14c6.94,1.37,13.88,2.87,20.79,4.44a785.09,785.09,0,0,1,279.28,125.68l.31.22a785.51,785.51,0,0,1,49.26-302.88c2.48-6.56,5-13.1,7.69-19.57,0-.15.09-.3.14-.46A183.54,183.54,0,0,0,1512.36,1478.15Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1657.06,912.2a183.93,183.93,0,0,0-158.28,45.06,478.66,478.66,0,0,1,8.62,122.84,495.82,495.82,0,0,1-7.61,61.7c-.33,1.79-.67,3.58-1.06,5.36a484,484,0,0,1-70.89,172.41A184.18,184.18,0,0,0,1702.21,1392l.4-.27c5.42-4.53,11-9,16.52-13.38A784.92,784.92,0,0,1,1992.33,1240l.37-.1A785.56,785.56,0,0,1,1788,1011.28c-3.55-6-7-12.15-10.4-18.28l-.27-.39A183.51,183.51,0,0,0,1657.06,912.2Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1704.55,712.11c0-.16,0-.32,0-.48,0-7,.1-14,.29-21a785.48,785.48,0,0,1,69.1-299l-.37.08a784.88,784.88,0,0,1-306.07,10.57q-10.5-1.74-20.93-3.76l-.48,0a184.2,184.2,0,0,0-205.42,195.78A484,484,0,0,1,1386,711.08c1.2,1.37,2.36,2.78,3.51,4.18a496.33,496.33,0,0,1,36.43,50.38,479.3,479.3,0,0,1,51.7,111.76,184.14,184.14,0,0,0,226.92-165.29Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1057,1423.78c22.57-57.89,1.1-125.73-26.51-169.9-32-51.14-77.17-93.31-120.92-134.05-54-50.4-110.13-104.82-150.23-167.61-37-57.93-55.42-119.17-53.24-177,1.38-36.47,10.88-69.84,27.66-99.13-117.13,81.57-194,217-194.72,370.54a455.11,455.11,0,0,0,94.6,279.32c60.58,78.32,146.49,135.72,242.21,161.16,36,9.55,77.23,15,113.26.63C1019.16,1475.74,1045.07,1454.47,1057,1423.78Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M928.62,671.48c-22.57,57.89-1.1,125.73,26.52,169.9,32,51.14,77.16,93.32,120.92,134.06,54,50.4,110.13,104.82,150.23,167.61,37,57.93,55.42,119.17,53.24,177-1.38,36.48-10.89,69.85-27.66,99.14,117.12-81.57,194-217,194.72-370.54A455.12,455.12,0,0,0,1352,769.33C1291.41,691,1205.5,633.61,1109.77,608.17c-36-9.56-77.22-15-113.25-.63C966.49,619.53,940.59,640.79,928.62,671.48Z",
    transform: "matrix(1, 0, 0, 1, -733.333313, -660.165161)",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.699b180bb513a9ef9d670c952075f89f.svg";
export { ForwardRef as ReactComponent };